import { bootstrapApplication } from '@angular/platform-browser';
import * as Sentry from '@sentry/angular';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';
import Gleap from 'gleap';

if (environment.GLEAP_ENABLED && environment.GLEAP_API_KEY) {
  Gleap.setLanguage('pt-BR');
  Gleap.initialize(environment.GLEAP_API_KEY);
}

Sentry.init({
  dsn: 'https://e96f6a22dcffc7604990d065faedf963@o142032.ingest.us.sentry.io/4509091861168129',
  enabled: environment.SENTRY_ENABLED,
  environment: environment.SENTRY_ENV,
  release:
    environment.GRAPHQL_CLIENT_VERSION === '<REPLACED_BY_CI_CD>'
      ? 'flux-client@1.0.0'
      : environment.GRAPHQL_CLIENT_VERSION,
  tracesSampleRate: 0.01,
  ignoreErrors: [
    // Persisted query errors
    /.*PersistedQueryNotFound.*/,
    /.*PERSISTED_QUERY_NOT_FOUND.*/,
    /You do not have the permission\(s\) .* to interact with this resource\./,

    /Fields required not answered/,
    /Card has tasks not completed/,

    /You must be signed in to view this resource\./,
    /Invariant Violation|An error occurred! For more details, see the full error text at https:\/\/go\.apollo\.dev\/.*/,
  ],
});

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
